import findLastIndex from './findLastIndex.js';
import createIndexFinder from './_createIndexFinder.js';

// Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.
export default createIndexFinder(-1, findLastIndex);



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/lastIndexOf.js
// module id = 1587
// module chunks = 106